import { concatMap, delay, retryWhen } from 'rxjs/operators';
import { of, throwError } from 'rxjs';

export function retry(times = 3, milliseconds = 1000) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (_target: object, _key: string, descriptor: TypedPropertyDescriptor<any>) => {
        const originalMethod = descriptor.value;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        descriptor.value = function (...args: any[]) {
            return originalMethod
                .apply(this, args)
                .pipe(retryWhen(error => error.pipe(concatMap((e, i) => (i >= times ? throwError(e) : of(e).pipe(delay(milliseconds)))))));
        };
        return descriptor;
    };
}
